module.exports = __webpack_public_path__ + "static/img/icon_article.b9a7ab6b.png";